import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

import { ButtonIwText } from '../ButtonIwText';

export const Card = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 24px;
  border: 1px solid ${COLORS.systemDark100};
  border-radius: 12px;
`;

export const CardItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  flex: 1;
  gap: 12px;
`;

export const CardTitle = styled.p`
  font-weight: 700;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const RowTitle = styled.p`
  color: ${COLORS.systemDark200};
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ButtonIwTextStyled = styled(ButtonIwText)`
  height: fit-content !important;
  padding: 0 !important;
  justify-content: flex-start !important;
  font-weight: 700 !important;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.h2`
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
`;
